import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { catchError, defaultIfEmpty, mergeMap, take, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { AcoesService } from '../acoes/acoes.service';
import { AnexarImagensComponent } from '../anexar-imagens/anexar-imagens.component';
import { AnexarImagensService } from '../anexar-imagens/anexar-imagens.service';
import { FinalizaGTO } from '../base/vo/finaliza-gto';
import { FinalizaProcedimento } from '../base/vo/finaliza-procedimento';
import { Gto } from '../base/vo/gto';
import { ProcedimentoCancela } from '../base/vo/procedimentoCancela';
import { SalvarDataDeRealizacaoDTO } from '../base/vo/salva-procedimento';
import { GtoTokenService } from '../gto-token/gto-token.service';
import { ModalSucessoComponent } from '../modal/modal-sucesso/modal-sucesso.component';
import { FinalizarGtoService } from './gto-finalizar.service';
import { ModalFinalizarComponent } from './modal-finalizar/modal-finalizar.component';
import { ModalSalvarAlteracoesComponent } from './modal-salvar-alteracoes/modal-salvar-alteracoes.component';


@Component({
  providers: [DatePipe],
  selector: 'app-gto-finalizar',
  styleUrls: ['./gto-finalizar.component.scss'],
  templateUrl: './gto-finalizar.component.html',
})
export class GtoFinalizarComponent implements OnInit, OnDestroy {

  @ViewChild('modalFinalizar')
  public modalFinalizar: ModalFinalizarComponent;

  @ViewChild('modalSalvarAlteracoes')
  public modalSalvarAlteracoes: ModalSalvarAlteracoesComponent;

  @ViewChild('modalSucesso')
  public modalSucesso: ModalSucessoComponent;

  @ViewChild('modalImagens')
  public modalImagens: AnexarImagensComponent;

  @ViewChild('modalSucessoGtoToken')
  public modalSucessoGtoToken: ModalSucessoComponent;

  @ViewChild('modalSucessoJustificativa')
  public modalSucessoJustificativa: ModalSucessoComponent;

  private sub: Subscription;
  private idGto: number;
  private formOrtodontia: any;
  private idsForCanceling: number[] = [];
  private onlyAttachView = false;
  private tokenExigido: string;

  // Variaveis datepicker
  private dateOverlays: boolean[] = [];
  private dateOverlaysAnimation: boolean[] = [];
  private dateErrors: boolean[] = [];
  private dateValues: string[] = [];

  public canOpenModalToken = false;
  public exibeOrtodontia = false;
  public finishing = false;
  public gto = new Gto();
  public loading = false;
  public saving = false;

  public errorDate = false;
  public errorGuia = false;

  public maxDate: Date;
  public minDate: Date;


  public ptbr = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto',
      'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  editImg = false;
  editErrors = null;

  constructor(
    private readonly acoesService: AcoesService,
    private readonly anexarImagensService: AnexarImagensService,
    private readonly datePipe: DatePipe,
    private readonly finalizarGtoService: FinalizarGtoService,
    private gtoTokenService: GtoTokenService,
    private readonly messageService: MessageService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) { }

  ngOnInit() {
    this.maxDate = new Date();

    this.sub = this.route.params.pipe(
      tap(params => {
        this.idGto = +params['numeroGTO'];
      })).subscribe();

    this._canOpenModalToken();

    this.getGto();

    this.anexarImagensService.anexosChangeEvent.pipe(
      tap(() => this.validateGuia())
    ).subscribe();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private scrollToProcedimentos() {
    setTimeout(() => {
      const procedimentosElement = document.getElementById('procedimentos');
      procedimentosElement.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  }

  private _canOpenModalToken() {
    this.gtoTokenService.getCanOpenModalTokenOnFinalizar().pipe(
      tap(response => this.canOpenModalToken = response)
    ).subscribe();
  }

  private getGto() {
    this.loading = true;
    this.finalizarGtoService.detalharGto(this.idGto).pipe(
      tap(data => {
        this.gto = data.data;

        if (this.gto.enviaCobrancaViaPortal === 'N' || this.gto.dataFinalizacao || !this.acoesService.getCanGoToFinalizar()) {
          this.router.navigate([`detalhagto/${this.gto.numero}`]);
        }

        if (this.gto.formularioOrtodontia) {
          this.exibeOrtodontia = this.gto.formularioOrtodontia.exibir;
          this.formOrtodontia = this.gto.formularioOrtodontia;
        }

        if (!this.gto.anexos) {
          this.gto.anexos = [];
        }

        this.minDate = new Date(this.getDataAutorizacao());

        this.gto.procedimentos.forEach(procedimento => {
          this.dateOverlays.push(false);
          this.dateOverlaysAnimation.push(false);
          this.dateErrors.push(false);

          if (procedimento.dataRealizacao) {
            procedimento.dataRealizacao = new Date(procedimento.dataRealizacao);
            this.dateValues.push(this.formatDate(procedimento.dataRealizacao));
          } else {
            this.dateValues.push('');
          }
        });

        this.gto.observacoesPrestador = '';

        this.loading = false;
      }),
      catchError(error => {
        this.loading = false;

        return of(error);
      }),
      mergeMap(_ =>
        this.acoesService.buscarConfigsToken().pipe(take(1))
      ),
      tap(response => {
        this.tokenExigido = response.data.tokenExigido;

        if (this.tokenExigido === '1' && this.canOpenModalToken) {
          if (this.gto.numeroToken) {
            this.modalSucessoGtoToken.openDialog();
          } else {
            this.modalSucessoJustificativa.openDialog();
          }
        }
      })
    ).subscribe();
  }

  private getSaveObservable() {
    if (this.finishing && this.validateGuia()) {
      const error = {
        error: {
          data: null,
          errors: [
            {
              objectName: "prestador",
              field: "anexo",
              message: "Anexo do tipo guia não localizado"
            }]
        }
      }
      return Observable.throw(error)
    }

    return this.acoesService.salvarGTO(this.gto);
  }

  private getProceduresObservable() {
    const salvarDataDeRealizacaoDTO: SalvarDataDeRealizacaoDTO = {
      procedimentos: this.gto.procedimentos.map(procedimento => {
        if (procedimento.permiteConfirmar === 'S') {
          return { linha: procedimento.linha, dataRealizacao: procedimento.dataRealizacao, finalizado: false };
        }
      }).filter(procedimento => procedimento)
    };

    return this.acoesService.salvarProcedimentos(this.gto.numero, salvarDataDeRealizacaoDTO);
  }

  private getCancelingObservables() {
    return this.idsForCanceling.map(id => {
      const procedimento = new ProcedimentoCancela(this.idGto, 'Finalizar Gto', id + 1);

      return this.acoesService.excluirProcedimento(procedimento);
    });
  }

  // Exibe ou esconde o datepicker
  public showHideDatepicker(show: boolean, index: number) {
    if (show) {
      this.dateOverlays[index] = show;
      setTimeout(() => {
        this.dateOverlaysAnimation[index] = show;
      }, 1);
    } else {
      this.dateOverlaysAnimation[index] = show;
      setTimeout(() => {
        this.dateOverlays[index] = show;
      }, 200);
    }

    this.dateErrors[index] = false;
  }

  public clearDate(index: number) {
    this.dateValues[index] = '';
    this.gto.procedimentos[index].dataRealizacao = null;
    this.showHideDatepicker(false, index);
  }

  public formatDate(date: Date) {
    return this.datePipe.transform(date, 'dd/MM/yyyy');
  }

  public applyDate(index: number) {
    this.dateValues[index] = this.formatDate(this.gto.procedimentos[index].dataRealizacao);
    this.showHideDatepicker(false, index);
    this.validateDatebyIndex(index);
  }

  public prepareToFinish() {
    this.modalSalvarAlteracoes.closeDialog();

    if (this.checkProcedures()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Procedimentos inválidos',
        detail: 'Não há procedimentos para serem finalizar'
      });

      return;
    }

    if (this.validateGuia()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Anexo do tipo guia inválido',
        detail: 'Anexo do tipo guia não foi anexado'
      });

      this.scrollToProcedimentos();

      return;
    }

    if (this.validateDate()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Procedimentos inválidos',
        detail: 'Verifique as datas dos procedimentos'
      });

      this.scrollToProcedimentos();

      return;
    }

    let erroToken = false;

    if (this.tokenExigido === '1' && this.canOpenModalToken) {
      erroToken = !(this.gto.numeroToken || this.gto.nomeJustificativaToken);
    }

    if (erroToken) {
      this.messageService.add({
        severity: 'error',
        summary: 'Token inválido',
        detail: 'Verifique o token ou a justificativa'
      });

      return;
    }

    this.modalFinalizar.openDialog();
  }

  public finish() {
    this.finishing = true;

    const finalizaProcedimento: FinalizaProcedimento[] = [];
    let cancelingObservables: Observable<any>[] = [];

    this.gto.procedimentos.forEach((procedimento, index) => {
      if (procedimento.dataRealizacao) {
        finalizaProcedimento.push(new FinalizaProcedimento(index + 1, procedimento.dataRealizacao, false));
      }
    });

    if (this.idsForCanceling.length) {
      cancelingObservables = this.getCancelingObservables();
    }

    const finalizaGTO = new FinalizaGTO(this.idGto, new Date(), finalizaProcedimento);

    forkJoin(cancelingObservables).pipe(
      defaultIfEmpty(null),
      mergeMap(_ => this.getSaveObservable()),
      mergeMap(_ => this.acoesService.finalizaGTO(finalizaGTO)),
      tap(_ => {
        this.finishing = false;
        this.modalFinalizar.closeDialog();
        this.modalSucesso.openDialog();
      }),
      catchError(error => {
        this.finishing = false;
        this.modalFinalizar.closeDialog();

        this.finalizarGtoService.displayErrors(error);
        this.goToDetalhe();

        return of(error);
      })
    ).subscribe();
  }

  public validateDate() {
    this.errorDate = false;

    this.gto.procedimentos.forEach((procedimento, index) => {
      if (procedimento.dataRealizacao) {
        if (this.dateValues[index] === '') {
          this.dateErrors[index] = true;
          this.errorDate = true;
        } else {
          this.dateErrors[index] = false;
        }
      } else {
        if (procedimento.permiteConfirmar === 'S') {
          if (this.dateValues[index] === '') {
            this.dateErrors[index] = true;
            this.errorDate = true;
          } else {
            this.dateErrors[index] = false;
          }
        }
      }
    });

    return this.errorDate;
  }

  public validateDatebyIndex(index: number) {
    this.errorDate = false;


    if (this.gto.procedimentos[index].dataRealizacao) {
      if (this.dateValues[index] === '') {
        this.dateErrors[index] = true;
        this.errorDate = true;
      } else {
        this.dateErrors[index] = false;
      }
    }

    return this.errorDate;
  }

  public validateGuia() {
    this.errorGuia = false;

    // Se a guia tiver numero token não precisa de anexo guia
    if (this.gto.numeroToken) {
      return this.errorGuia;
    }

    const anexo = this.gto.anexos.filter(x => x.codigoTipo === '3' && x.codigoSituacao === '2');

    if (!anexo.length) {
      this.errorGuia = true;
    }

    return this.errorGuia;
  }

  public save() {
    this.saving = true;
    let observables: Observable<any>[] = [];

    window.scroll(0, 0);

    if (this.idsForCanceling.length) {
      observables = this.getCancelingObservables();
    }

    if (this.gto.anexos.length) {
      observables.push(this.getSaveObservable());
    }

    observables.push(this.getProceduresObservable());

    forkJoin(observables).pipe(
      tap(_ => {
        this.saving = false;
        this.modalSalvarAlteracoes.openDialog();
      }),
      catchError(error => {
        this.saving = false;

        this.finalizarGtoService.displayErrors(error);
        this.goToDetalhe();

        return of(error);
      })
    ).subscribe();
  }

  public cancelProcedure(index: number) {
    this.gto.procedimentos[index].status = 'cancelado';
    this.gto.procedimentos[index].permiteConfirmar = 'N';
    this.idsForCanceling.push(index);
  }

  public abrirModalAnexos() {
    this.modalImagens.display = true;
  }

  public goToDetalhe() {
    this.router.navigate(['detalhagto', this.idGto]);
  }

  public getDataAutorizacao() {
    return this.gto.dataPrimeiraAut ? this.gto.dataPrimeiraAut : this.gto.dataProtocolo;
  }

  public attachError(error: boolean) {
    this.onlyAttachView = error;
  }

  public permitirAnexarImagem() {
    return !this.onlyAttachView;
  }

  public checkProcedures() {
    return this.gto.procedimentos.every(x => x.status.toUpperCase() === 'CANCELADO');
  }

  public confirmGtoTokenSuccessModal() {
    this.modalSucessoGtoToken.closeDialog();
  }

  public confirmJustificativaSuccessModal() {
    this.modalSucessoJustificativa.closeDialog();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-finalizar/gto-finalizar.component.ts